import { User } from './user';
import { Warehouse } from './warehouse';

export class LoadingBay {
  name!: string;
  description?: string;
  warehouse_uuid!: string;
  occupation_status!: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  warehouse?: Warehouse;

  static getSortColumns() {
    return ['name', 'description', 'occupation_status', 'status'];
  }

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.warehouse_uuid = data.warehouse_uuid;
    this.occupation_status = data.occupation_status;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.warehouse) {
      this.warehouse = new Warehouse(data.warehouse);
    }
  }
}
